import CodePrettifier, { vmtLogLanguage, vmtLogTheme } from './CodePrettifier';
import XMLCodePrettifier from 'components/CodePrettifier/XMLCodePrettifier';
import JSCodePrettifier from 'components/CodePrettifier/JSCodePrettifier';
import ExecutionLogCodePrettifier from 'components/CodePrettifier/ExecutionLogCodePrettifier';

export default CodePrettifier;
export { vmtLogLanguage, vmtLogTheme, XMLCodePrettifier, JSCodePrettifier, ExecutionLogCodePrettifier };
